import React from "react";
import { useLocation } from 'react-router-dom';
import { FaUserCircle, FaUserTie  } from 'react-icons/fa'; // Ícone de usuário do react-icons

const MenuSuperior = ({ userId, userName, cliente }) => {
  const location = useLocation();
  const currentPath = location.pathname.split('/').filter(Boolean).join('/');

  return (
    <div style={styles.navbar}>
      <div style={styles.userInfo}>
        <FaUserCircle style={styles.icon} />
        <span>{userId} - {userName}</span>
      </div>
      {cliente && (
        <div style={styles.pathInfo}>
          <FaUserTie style={styles.icon} />
          <span style={{ color: 'white' }}>{cliente}</span>
        </div>
      )}
    </div>
  );
};

const styles = {
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    paddingLeft: '5%',
    backgroundColor: 'rgb(99, 100, 100)',
    color: 'white',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    marginRight:'1.3%'
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '10px',
    fontSize: '20px',
    color: 'rgb(230, 236, 233)',
  },
  pathInfo: {
    fontSize: '14px',
    color: 'rgb(44, 49, 46)',
    textAlign: 'right',
  },
};

export default MenuSuperior;
